var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.request)?_c('div',{class:_vm.classObj,attrs:{"title":"click to confirm"},domProps:{"innerHTML":_vm._s(_vm.requestBr)},on:{"click":function($event){_vm.checked = ! _vm.checked}}}):_vm._e(),_vm._v(" "),(! _vm.request)?_c('div',{staticClass:"uk-text-muted"},[_vm._v("\n        요청사항이 없습니다\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }